import { MockCard, MockButton, MockSearchInput, MockLink } from '../../components/mockups/MockUI'
import { MockTable } from '../../components/mockups/MockTable'
import { MockBadge } from '../../components/mockups/MockBadge'

export function CatalogOverview() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Раздел «Каталог»
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          «Каталог» — полный реестр партномеров компании: наложение справочника УНФ и ручных
          категорий. Любая новая позиция заявки автоматически регистрируется в каталоге, поэтому
          здесь видно всё, что когда-либо запрашивали клиенты. В шапке — счётчик «всего
          партномеров».
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-3">
          <div className="font-medium text-gray-800 dark:text-gray-200">Как устроена страница:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Слева — список «Сегменты» (Конденсатор, Микросхема, Разъём…) со счётчиком партов в
              каждом; пункт «Все сегменты» показывает весь каталог с кнопкой{' '}
              <MockButton variant="secondary">Загрузить ещё</MockButton>
            </li>
            <li>
              Группа «— Без сегмента» — парты, попавшие в каталог автоматически из позиций заявок, у
              которых «Наименование» ещё не задано (метка «из заявки» у артикула)
            </li>
            <li>Справа — таблица: Артикул / Наименование / Бренд / Сегмент</li>
            <li>
              Клик по артикулу открывает карточку парта: спрос (в каких заявках встречался), закупка
              (цены поставщиков), продажи (заказы)
            </li>
          </ul>
        </div>
      </MockCard>
      <MockSearchInput placeholder="Поиск по артикулу, наименованию или сегменту…" />
      <MockTable
        caption="Таблица партномеров"
        columns={[
          { header: 'Артикул' },
          { header: 'Наименование' },
          { header: 'Бренд' },
          { header: 'Сегмент' },
        ]}
        rows={[
          ['B82442A1152-K', 'Дроссель B82442A1152-K', 'TDK', 'Дроссель'],
          ['GRM188R71H104KA93D', 'Конденсатор керамический 0.1мкФ', 'Murata', 'Конденсатор'],
          ['STM32F103C8T6', '—', 'ST', '— без сегмента'],
        ]}
      />
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <p>
            Редактировать каталог могут только ADMIN и РОП: кнопка{' '}
            <MockButton variant="secondary">+ Добавить парт</MockButton> (поля «Партномер» и
            «Сегмент»), смена сегмента прямо в ячейке таблицы, кнопка ✕ убирает ручной оверрайд.
            Остальные роли видят каталог в режиме просмотра.
          </p>
          <p className="font-medium text-gray-800 dark:text-gray-200">
            Правки применяются только к новым заявкам — наименование в уже созданных позициях не
            меняется.
          </p>
        </div>
      </MockCard>
    </div>
  )
}

export function CatalogNaming() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          «Наименование» позиции
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          «Наименование» — короткая категория компонента (конденсатор, микросхема, разъём…).
          Заполняется автоматически при вставке списка позиций в новую заявку и видно в колонке
          «Наименование» — на форме создания заявки и в таблице позиций карточки заявки.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-3">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Как система определяет наименование (по порядку):
          </div>
          <ol className="list-decimal list-inside space-y-1">
            <li>Справочник номенклатуры УНФ — парт найден по артикулу, категория точная</li>
            <li>Правила по партномеру — по структуре артикула (в т.ч. русские 2РМ…, СНЦ…)</li>
            <li>Подсказка по бренду — категория выведена из производителя, а не из партномера</li>
            <li>Ничего не подошло — поле остаётся пустым, менеджер вписывает вручную</li>
          </ol>
        </div>
      </MockCard>
      <MockTable
        caption="Светофор наименования — цвет текста в ячейке"
        columns={[{ header: 'Статус' }, { header: 'Что значит' }, { header: 'Что делать' }]}
        rows={[
          [
            <MockBadge color="green">GREEN — точно</MockBadge>,
            'Категория из справочника УНФ или по правилу партномера',
            'Ничего, можно доверять',
          ],
          [
            <MockBadge color="orange">YELLOW — предположение</MockBadge>,
            'Категория по бренду или по обученному правилу семейства',
            'Проверить и при необходимости поправить',
          ],
          [
            <MockBadge color="red">RED — не определено</MockBadge>,
            'Парта нет в справочнике, правила и бренд не подошли',
            'Вписать наименование вручную',
          ],
        ]}
      />
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <p>
            При наведении на жёлтую или красную ячейку появляется подсказка с причиной: «Категория
            определена по бренду (не по партномеру) — проверьте», «Наименование не распознано (нет в
            справочнике, не подошли правила/бренд) — укажите вручную» и т.п.
          </p>
          <p>
            В карточке заявки колонку «Наименование» могут править менеджер, РОП, помощник и ADMIN —
            как обычную ячейку таблицы. Пустое значение показывается как «—».
          </p>
        </div>
      </MockCard>
    </div>
  )
}

export function CatalogLearning() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Самообучение
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Система запоминает ручные правки «Наименования» — со временем красных позиций становится
          меньше: то, что один раз вписали вручную, дальше подставляется автоматически.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-3">
          <div className="font-medium text-gray-800 dark:text-gray-200">Два уровня обучения:</div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              <span className="font-medium">Точное запоминание парта</span> — исправили наименование
              на форме создания заявки или в карточке заявки → этот партномер в новых заявках
              распознаётся зелёным (точно)
            </li>
            <li>
              <span className="font-medium">Семейства партов</span> — если два и более разных
              партномера одного семейства (общее «ядро» артикула) получили одну категорию, новые
              парты этого семейства распознаются жёлтым (предположение — проверьте)
            </li>
          </ul>
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Правка в «Каталоге» — авторитетна:
          </div>
          <ul className="list-disc list-inside space-y-1">
            <li>
              Смена сегмента в разделе «Каталог» или в карточке парта (кнопка{' '}
              <MockButton variant="secondary">Редактировать</MockButton> — бренд / наименование /
              сегмент, доступна ADMIN и РОП) перебивает справочник и правила для новых заявок
            </li>
            <li>
              Старые заявки хранят свой снапшот наименования — задним числом ничего не меняется
            </li>
            <li>
              У парта с ручной правкой в таблице каталога стоит метка «правка»; кнопка ✕ убирает
              оверрайд — парт возвращается к категории справочника УНФ
            </li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function CatalogUnfExport() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Выгрузка в УНФ и защита от дублей
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          При оформлении заказа система формирует Excel-шаблон счёта для 1С:УНФ (кнопка «Выгрузить
          шаблон счёта (УНФ)» в карточке заявки). Главная задача — чтобы УНФ не плодила дубли
          номенклатуры.
        </p>
      </div>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-3">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Откуда берётся полное «Наименование» для счёта (по порядку):
          </div>
          <ol className="list-decimal list-inside space-y-1">
            <li>
              Парт есть в справочнике УНФ → «Наименование» и «Артикул» берутся оттуда 1-в-1 (с
              пробелами как есть — иначе УНФ создаст новую номенклатуру)
            </li>
            <li>
              В карточке парта в «Каталоге» вручную задано полное наименование → берётся оно
              (каталог — место, где заранее готовят правильное имя будущей номенклатуры)
            </li>
            <li>
              Иначе наименование собирается как «категория + партномер»; если категории нет — просто
              партномер
            </li>
          </ol>
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Кириллица-двойники в латинице:
          </div>
          <p>
            Частая причина дублей — русские буквы А, В, С, Е, О, Р… в латинском партномере: на
            экране выглядят одинаково, но для системы это разные артикулы. При вставке списка в
            новую заявку парсер подсвечивает такие строки: «⚠ кириллица в артикуле» с выделенной
            красным буквой и правильным вариантом «→ латиница «…»». Позиция помечается красным —
            поправьте партномер до отправки.
          </p>
          <p>
            Проверить любой парт можно в карточке парта (раздел «Каталог» →{' '}
            <MockLink>клик по артикулу</MockLink>): там видны каноническое написание, код УНФ,
            бренды и вся история — заявки, квоты, заказы.
          </p>
        </div>
      </MockCard>
    </div>
  )
}
